import { render, staticRenderFns } from "./Destination.vue?vue&type=template&id=1562d6e7&scoped=true"
import script from "./Destination.vue?vue&type=script&lang=js"
export * from "./Destination.vue?vue&type=script&lang=js"
import style0 from "./Destination.vue?vue&type=style&index=0&id=1562d6e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1562d6e7",
  null
  
)

export default component.exports